<template>
  <div class="direction__up">
    <div class="direction__title-container">
      <div class="direction__title">
        <div class="text-h5 mod--title">
          <span>{{ node.data.name }}</span>
          <IconCount
            v-if="node.data.events_unread_count"
            :count="node.data.events_unread_count"
          />
        </div>

        <div class="title__attention">
          <LKRoadmapsFeedAttentionDrop
            v-if="node.data.description"
            :description="node.data.description"
          />
        </div>
      </div>
    </div>
    <div class="up__label mod--direction">
      <LKRoadmapsFeedLabelConfirm
        :confirmed="node.data.is_confirmed"
      />

      <template v-if="isAdresat && !isCoordinator && !node.data.is_required">
        <v-tooltip :disabled="!removeDisabled" top>
          <template #activator="{ attrs, on }">
            <div v-bind="attrs" v-on="on">
              <IconTrash
                :loading="isLoading"
                :class="{ 'cursor-default': removeDisabled }"
                @click.native="onRemoveDirection"
              />
            </div>
          </template>
          <div
            style="max-width: 240px;"
            v-text="removeTooltipText"
          />
        </v-tooltip>
      </template>
    </div>
    <div class="direction__up__footer text-sm mod--status-direction">
      <span>Мер, требующих внимания: {{ node.data.attention_count }}</span>
      <br>
      <LKRoadmapsFeedTitleStatuses
        :node-data="node.data"
      />
    </div>
  </div>
</template>

<script>
import IconTrash from '@/components/lk/icons/LKIconTrash.vue'
import IconCount from '@/components/lk/icons/LKIconCount.vue'
import LKRoadmapsFeedLabelConfirm from '../ui/LKRoadmapsFeedLabelConfirm.vue'
import LKRoadmapsFeedAttentionDrop from '../ui/LKRoadmapsFeedAttentionDrop.vue'
import LKRoadmapsFeedTitleStatuses from '../ui/LKRoadmapsFeedTitleStatuses.vue'


export default {
  name: 'LKRoadmapsFeedCardDirectionUp',
  inject: [
    'isAdresat',
    'isCurator',
    'isCoordinator',
  ],
  components: {
    IconTrash,
    IconCount,
    LKRoadmapsFeedLabelConfirm,
    LKRoadmapsFeedAttentionDrop,
    LKRoadmapsFeedTitleStatuses,
  },
  inheritAttrs: false,
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    removeDisabled() {
      return (
        this.node.data.is_required
        || this.hasFilesInEvents
      )
    },
    hasFilesInEvents() {
      return this.node.data.events.some((event) => (
        event.files.length
      ))
    },
    removeTooltipText() {
      if (this.node.data.is_required) {
        return 'Обязательное направление нельзя удалять'
      }

      if (this.hasFilesInEvents) {
        return 'Нельзя удалить направление, если есть загруженные файлы у мер'
      }

      return 'Нельзя удалять'
    },
  },
  methods: {
    onRemoveDirection() {
      if (this.removeDisabled) return
      this.$emit('remove-direction', this.node, this.toggleLoading)
    },
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
  },
}
</script>
